import { Component, EventEmitter, HostBinding, Output, ViewChild, inject } from '@angular/core';
import { Location, NgOptimizedImage } from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {SvgIconComponent} from '@ngneat/svg-icon';
import {environment} from '../../../environments/environment';
import {UserService} from '../../services/user.service';
import {User} from '../../models/user';
import {LayoutClassDirective} from '../../services/directives/layout-class.directive';
import {OverlayscrollbarsModule} from 'overlayscrollbars-ngx';
import {osLight} from '../overlay-scroll-options';
import {DialogComponent} from '../../components/modal-dialog/dialog.component';
import {
	WaIntersectionObservee,
	WaIntersectionObserverDirective,
	WaIntersectionRoot
} from '@ng-web-apis/intersection-observer';
import {EventService, MenuState} from '../../services/event.service';

@Component({
    selector: 'app-navigation',
	imports: [
    RouterLink,
    RouterLinkActive,
    SvgIconComponent,
    OverlayscrollbarsModule,
    DialogComponent,
    NgOptimizedImage,
    WaIntersectionObserverDirective,
    WaIntersectionRoot,
    WaIntersectionObservee
],
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    hostDirectives: [LayoutClassDirective]
})
export class NavigationComponent {
	private location = inject(Location);
	private userService = inject(UserService);
	private eventService = inject(EventService);

	@ViewChild('logoutDialog') logoutDialog?: DialogComponent;
	isDevelopment = environment.development;

	isScrolled = false;

	@Output()
	closeMenu = new EventEmitter<void>();

	user?: User;

	currentLocation?: string;
	login = () => {
		this.userService.login(this.currentLocation);
		this.close();
	}

	logout = () => this.userService.logout();

	menuState?: MenuState;
	@HostBinding('class.open')
	get open() {
		return this.menuState === MenuState.open
	}

	constructor() {
		this.userService.user.subscribe(x => this.user = x);
		this.location.onUrlChange(url => this.currentLocation = url);
		this.eventService.menuState.subscribe(menuState => this.menuState = menuState);
	}

	close = (): void => this.eventService.setMenu(MenuState.closed);
	protected readonly osLight = osLight;
}
